import { getRouteApi } from '@tanstack/react-router';
import * as React from 'react';

import { useAuthRefresh } from '@/auth/auth-context';
import {
  ActivationScreen,
  type ActivationOutcome,
} from '@/routes/onboarding/activation-screen';

// =============================================================================
// activation-route.tsx — Adaptateur routeur de l'écran d'activation (S0-ACTIVATION, F1).
// =============================================================================
// Lit le token d'activation depuis le path param d'URL (`/onboarding/activate/$token`,
// TanStack Router) et, à la confirmation des coordonnées, route vers la suite de
// l'onboarding : CGU (F-02) si non signées, tableau de bord fournisseur (§3.2, `/dashboard`)
// sinon (EF-IDA-4). Route DISTINCTE du magic-link (`/onboarding/$token`, reconnexion) — F1 = A
// (routes distinctes). Le token vit dans l'URL (pas de localStorage, RULE_REF_006) — le lien
// e-mail EST l'URL.

const routeApi = getRouteApi('/onboarding/activate/$token');

export function ActivationRoute(): React.JSX.Element {
  const { token } = routeApi.useParams();
  const navigate = routeApi.useNavigate();
  // F2 : l'activation a ouvert une NOUVELLE session fournisseur (cookie httpOnly). On re-résout
  // l'identité (whoami + me) AVANT de naviguer, pour que l'AuthState porte role:'supplier' dès
  // l'arrivée sur '/dashboard' ou '/cgu' (sinon la nav resterait en interim admin). NO-OP hors
  // bootstrap.
  const { refresh } = useAuthRefresh();

  const onConfirmed = React.useCallback(
    async (outcome: ActivationOutcome): Promise<void> => {
      await refresh();
      // DBU §3.1 l.2356-2364 / §3.2 : destination post-activation = tableau de bord fournisseur,
      // JAMAIS '/' (landing/auth ADMIN, §2.1 l.514/574 — séparation ferme des mondes, §1.3 l.374).
      void navigate({
        to: outcome.hasSigned ? '/dashboard' : '/cgu',
      });
    },
    [navigate, refresh],
  );

  return <ActivationScreen token={token} onConfirmed={onConfirmed} />;
}
